import { useSyncExternalStore } from 'react'

// whether the browser thinks it is online, followed live (a picture that failed
// to load retries when the connection comes back)
const onlineNow = () => navigator.onLine
const onOnlineChange = (fire: () => void) => {
  window.addEventListener('online', fire)
  window.addEventListener('offline', fire)
  return () => {
    window.removeEventListener('online', fire)
    window.removeEventListener('offline', fire)
  }
}

export const useBrowserOnline = () => useSyncExternalStore(onOnlineChange, onlineNow, () => true)
